import React, { useState } from 'react';
import lhLogo from '../assets/Logos/LH_logo.jpg';
import incheonAirportLogo from '../assets/Logos/인천공항_logo.jpg';
import hugLogo from '../assets/Logos/Hug_logo.jpg';
import gasCorporationLogo from '../assets/Logos/가스공사_logo.jpg';
import hydropowerLogo from '../assets/Logos/수력원자력_logo.jpg';
import nuclearEnvironmentLogo from '../assets/Logos/원자력환경_logo.jpg';
import districtHeatingLogo from '../assets/Logos/지역난방공사_logo.jpg';
import koreaRacingLogo from '../assets/Logos/한국마사회_logo.jpg';
import roadCorporationLogo from '../assets/Logos/한국도로공사_logo.jpg';
import postalServiceLogo from '../assets/Logos/우정사업본부_logo.jpg';
import kepcoLogo from '../assets/Logos/한국전력공사_logo.jpg';
import sudoLogo from '../assets/Logos/수도권매립지관리공사_logo.jpg';
import jdcLogo from '../assets/Logos/JDC_logo.jpg';
import kwaterLogo from '../assets/Logos/수자원공사_logo.jpg';
import kWaterManagementLogo from '../assets/Logos/케이워터_logo.jpg';
import kesLogo from '../assets/Logos/한국전기안전공사_logo.jpg';
import koreaEmploymentLogo from '../assets/Logos/한국고용정보원_logo.jpg';
import smallBusinessLogo from '../assets/Logos/소상공인시장진흥공단_logo.jpg';
import gyeongnamLogo from '../assets/Logos/경상남도_logo.jpg';
import constructionWelfareLogo from '../assets/Logos/건설근로자공제회_logo.jpg';

function Projects() {
  const [activeTab, setActiveTab] = useState('org');

  const projectsData = {
    org: {
      title: 'Organization & Workforce Design',
      subtitle: '조직진단, 조직재설계, 직무분석, 적정인력 산정 등 전반',
      projects: [
        { name: 'LH 조직진단 및 인력재배치', logo: lhLogo, company: 'LH 한국토지주택공사' },
        { name: 'LH 주거복지사업 조직인력분석', logo: lhLogo, company: 'LH 한국토지주택공사' },
        { name: '인천국제공항공사 직무중심 조직운영체계 혁신', logo: incheonAirportLogo, company: '인천국제공항공사' },
        { name: '한국수력원자력 조직재설계', logo: hydropowerLogo, company: '한국수력원자력' },
        { name: 'HUG 조직진단 및 중장기 조직인력계획', logo: hugLogo, company: '주택도시보증공사' },
        { name: '우정사업본부 집배분야 조직진단', logo: postalServiceLogo, company: '우정사업본부' },
        { name: '한국전력공사 배전분야 직무분석', logo: kepcoLogo, company: '한국전력공사' },
        { name: '한국도로공사 콜센터 인력산정', logo: roadCorporationLogo, company: '한국도로공사' }
      ]
    },
    strategy: {
      title: 'Strategy & Management Consulting',
      subtitle: '중장기 전략, 혁신과제, 경영체계 개선 등 전반',
      projects: [
        { name: '한국마사회 사업구조 및 조직 재설계 컨설팅', logo: koreaRacingLogo, company: '한국마사회' },
        { name: '수도권매립지관리공사 중장기 경영전략', logo: sudoLogo, company: '수도권매립지관리공사' },
        { name: 'JDC 시행계획 및 중장기 전략수립', logo: jdcLogo, company: '제주국제자유도시개발센터' },
        { name: '한국가스공사 혁신계획 수립', logo: gasCorporationLogo, company: '한국가스공사' },
        { name: '한국지역난방공사 사회적가치 전략 수립', logo: districtHeatingLogo, company: '한국지역난방공사' },
        { name: '한국도로공사 사회적가치 성과 고도화', logo: roadCorporationLogo, company: '한국도로공사' },
        { name: '수자원공사 사업전략 고도화', logo: kwaterLogo, company: '한국수자원공사' }
      ]
    },
    process: {
      title: 'Process & Operating Model',
      subtitle: '운영모델 설계, 프로세스 개선, 유지관리체계 구축 등 전반',
      projects: [
        { name: '한국도로공사 유지관리체계 구축', logo: roadCorporationLogo, company: '한국도로공사' },
        { name: '스마트톨링 시범사업 성과진단', logo: roadCorporationLogo, company: '한국도로공사' },
        { name: '케이워터운영관리 직무분석', logo: kWaterManagementLogo, company: '케이워터' },
        { name: '한국전력공사 고객센터 발전방안', logo: kepcoLogo, company: '한국전력공사' },
        { name: '한국전기안전공사 고객센터 구축', logo: kesLogo, company: '한국전기안전공사' }
      ]
    },
    research: {
      title: 'Public Policy & Research',
      subtitle: '정책연구, 실태조사, 평가, 타당성 검토',
      projects: [
        { name: '한국고용정보원 재정지원 일자리사업 모니터링', logo: koreaEmploymentLogo, company: '한국고용정보원' },
        { name: '수도권매립지 종합환경관리계획', logo: sudoLogo, company: '수도권매립지관리공사' },
        { name: '소상공인시장진흥기금 운용효율화 연구', logo: smallBusinessLogo, company: '소상공인시장진흥공단' },
        { name: '경상남도 출자출연기관 경영실적평가', logo: gyeongnamLogo, company: '경상남도' },
        { name: '건설근로자공제회 내부평가', logo: constructionWelfareLogo, company: '건설근로자공제회' },
        { name: '원자력환경공단 평가제도 운영', logo: nuclearEnvironmentLogo, company: '한국원자력환경공단' }
      ]
    }
  };

  const tabs = [
    { id: 'org', label: '조직 & 인력설계' },
    { id: 'strategy', label: '전략 & 경영' },
    { id: 'process', label: '프로세스 & 운영' },
    { id: 'research', label: '공공정책 & 연구' }
  ];

  return (
    <section id="projects" className="projects-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Major Project Experience</h2>
          <div className="title-underline"></div>
        </div>
        
        <div className="projects-tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="projects-content">
          <div className="tab-content active">
            <h3 className="projects-category-title">{projectsData[activeTab].title}</h3>
            <p className="projects-category-subtitle">{projectsData[activeTab].subtitle}</p>
            <div className="projects-list">
              {projectsData[activeTab].projects.map((project, index) => (
                <div key={index} className="project-item">
                  {project.logo ? (
                    <div className="project-logo">
                      <img src={project.logo} alt={project.company} />
                    </div>
                  ) : (
                    <div className="project-icon">✓</div>
                  )}
                  <div className="project-info">
                    <div className="project-name">{project.name}</div>
                    <div className="project-company">{project.company}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Projects;
